import Api from './ApiRequest';

export default {
    getAll: (params) => Api.get('/cent/themes', params),
};